export const EVENT_NONE = 0;
export const EVENT_OPEN = EVENT_NONE + 1;
export const EVENT_VOTE = EVENT_OPEN + 1;
